import React, { useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import { useAuth } from '../../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function UpvoteButton({ discussionId, initialCount, initialUpvoted = false, layout = 'vertical' }) {
  const { currentUser, token } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(initialCount || 0);
  const [upvoted, setUpvoted] = useState(initialUpvoted);
  const [loading, setLoading] = useState(false);

  const handleUpvote = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!currentUser) {
      navigate('/auth');
      return;
    }

    if (loading) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/discussions/${discussionId}/upvote`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      
      if (data.success) {
        setUpvoted(data.upvoted);
        setCount(prev => data.upvoted ? prev + 1 : prev - 1);
      }
    } catch (error) {
      console.error("Upvote failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button 
      onClick={handleUpvote}
      disabled={loading}
      className={`btn btn-sm d-flex align-items-center justify-content-center gap-1 ${layout === 'vertical' ? 'flex-column' : 'flex-row'} ${upvoted ? 'btn-warning text-dark' : 'btn-outline-secondary'}`}
      style={{ minWidth: layout === 'vertical' ? '50px' : 'auto', padding: layout === 'horizontal' ? '4px 10px' : '' }}
    >
      <FaChevronUp />
      <span className="fw-bold">{count}</span>
    </button>
  );
}
